import { render } from "./VideoDetails.vue?vue&type=template&id=19cbcfb8"
import script from "./VideoDetails.vue?vue&type=script&lang=ts"
export * from "./VideoDetails.vue?vue&type=script&lang=ts"

import "./VideoDetails.vue?vue&type=style&index=0&id=19cbcfb8&lang=css"
script.render = render

export default script